/**
 * ReliabilityBadge — presentation of a claim's existing reliability token.
 * Reliability labels are omitted from reports; their free-text qualifiers
 * remain readable and the parsed reliability is retained as metadata.
 *
 *   verified   — direct provider data / uploaded doc / named source
 *   inferred   — LLM-derived from related data / regional baseline
 *   unverified — no underlying data; LLM training-corpus only
 *
 * This changes presentation only, not the source token or evidence status.
 */
import React from 'react';
import type { ClaimReliability } from '../../../lib/claimReliability';

interface Props {
  reliability: ClaimReliability;
  /** Free-text qualifier captured from the inline token (optional). */
  qualifier?: string;
}

export const ReliabilityBadge: React.FC<Props> = ({ reliability, qualifier }) => {
  if (reliability !== 'unverified') {
    return qualifier ? <span data-reliability={reliability}>({qualifier})</span> : null;
  }
  return (
    <span
      data-reliability={reliability}
      data-testid={`reliability-badge-${reliability}`}
    >
      {qualifier ? `(${qualifier})` : null}
    </span>
  );
};
